module.exports = __webpack_public_path__ + "img/tisue.8da167bf.png";